<app-table
  *ngIf='ready'
  [columns]='tableColumns'
  [dataSourceParams]='dataSourceParams'
  [dataSource]='dataSource'
  [selectable]='false'></app-table>
